import React, { Component } from 'react';
import Hello from './components/Hello'
import './App.css';
import { connect } from 'react-redux';

// Actions
import { testAction } from './actions/Test'

class App extends Component {

    constructor(props){
        super(props);
        this.state = {
            count: 0
        }
    }

    add(){
        this.setState({count:this.state.count+=1});
    }

    test(){

        // Dispath
        this.props.testAction();

    }

    renderItems(){

        if(!this.props.Test.items) return;
        return this.props.Test.items.map(item => {
            return (<li>{item}</li>)
        })

    }

  render() {
    return (
      <div className="App">
        <h1>TheChurchCo Web Components</h1>
        <p>{this.props.name}</p>
        <Hello name={this.props.name}/>
        <b>The Count Is: {this.state.count}</b>
        <p>
            <button onClick={() => this.add()}>Add</button>
            <button onClick={() => this.test()}>Test Redux</button>
        </p>

        <p>Prop Name: {this.props.Test.name}</p>
        <ul>{this.renderItems()}</ul>
      </div>
    );
  }
}

const mapStateToProps = state => ({
 ...state
})

const mapDispatchToProps = dispatch => ({
 testAction: () => dispatch(testAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(App);
